<template>
  <div id="pricing-wrapper">
    <h1>{{ $t('simpleSubscription') }}<br />{{ $t('noSurprises') }}</h1>
    <p class="subheader">{{ $t('tryItFree30days') }} {{ $t('noCreditCardRequired') }}</p>
    <div id="plans-wrapper">
      <PriceCard
        v-for="card in cards"
        :key="card"
        :name="card.name"
        :descritption="card.descritption"
        :price="card.price"
        :price-desc="card.priceDesc"
        :asterisk="card.asterisk"
        :features="card.features"
        :link="card.link"
        :link-type="card.linkType"
        :link-name="card.linkName"
      />
    </div>
  </div>
</template>

<script>
import PriceCard from '@/components/main_page/PriceCard.vue'
import Parse from 'parse'
import BaseComponent from '@/components/BaseComponent'

export default {
  components: {
    PriceCard,
  },
  mixins: [BaseComponent],
  data() {
    return {
      cards: [
        {
          name: this.$t('free'),
          descritption: this.$t('forSmallTeams'),
          price: '€0',
          priceDesc: this.$t('upTo5PersonsFree'),
          features: [
            this.$t('flexibleWorkCalendars'),
            this.$t('timeOffManagement'),
            this.$t('multipleTimezonesSupport'),
            this.$t('multipleWorkplaces'),
            this.$t('homeOfficeAndRemote'),
            this.$t('smartNotifications'),
          ],
          link: this.getUrl('register', 'pricing-free'),
          linkType: 'secondary',
          linkName: this.$t('signUpItsFree'),
        },
        {
          name: this.$t('standard'),
          descritption: this.$t('forBiggerTeams'),
          price: '€4,20',
          priceDesc: this.$t('perPersonBilledAnually'),
          features: [
            this.$t('unlimitedTeamMembers'),
            this.$t('multipleTeamsUpTo10'),
            this.$t('unlimitedManagers'),
            // 'Calendar integration',
            this.$t('slackIntegrationStandard'),
          ],
          link: this.getUrl('register', 'pricing-standard'),
          linkType: 'primary',
          linkName: this.$t('tryItFree'),
          asterisk: this.$t('excludingVAT'),
        },
      ],
    }
  },
  async created() {
    // var Client = require("node-rest-client").Client;
    Parse.initialize(process.env.VUE_APP_PARSE_SERVER_APPLICATION_ID, process.env.VUE_APP_PARSE_SERVER_API_KEY)
    Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL
    let lang = navigator.language
    let countryCode = lang.substring(0, 2).toUpperCase()
    let prices = await Parse.Cloud.run('getPriceOfOneUnitNoTax', { countryCode, plan: 'standardYearly' }, {})
    this.cards[1].price = prices.pricePerMemberMonthlyNoTaxFormatted
    this.cards[0].price = prices.pricePerMemberFreeFormatted
  },
}
</script>

<style lang="scss" scoped>
#pricing-wrapper {
  text-align: center;

  max-width: $maxWidth;
  margin: 130px auto 0px auto;

  @include respond-above(sm) {
    margin-bottom: 0;
  }
  @include respond-above(md) {
  }

  h2 {
    margin: 0 0 48px;
  }
  p {
    max-width: $maxWidth - 320px;
    margin: 0 auto 60px auto;
    text-align: center;
  }

  #plans-wrapper {
    margin-top: 60px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    @include respond-above(sm) {
      flex-direction: row;
    }
  }
}
</style>
